import { apiClient } from './client';
import { User } from '../types';

interface LoginResponse {
    access_token: string;
    token_type: string;
}

export const authService = {
    login: async (username: string, password: string): Promise<LoginResponse> => {
        const formData = new URLSearchParams();
        formData.append('username', username);
        formData.append('password', password);

        // FastAPI OAuth2PasswordRequestForm expects x-www-form-urlencoded
        const response = await apiClient.post<LoginResponse>('/auth/login', formData, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
        return response.data;
    },

    register: async (username: string, password: string): Promise<any> => {
        const response = await apiClient.post<any>('/auth/register', { username, password });
        return response.data;
    },

    getMe: async (): Promise<User> => {
        const response = await apiClient.get<User>('/auth/me');
        return response.data;
    }
};
